<template>
  <div class="motorcycle-detail">
    <div class="section-title">赛博/监管信息:</div>
    <MotorcycleManualStudyPanel ref="manualStudyPanel" :detail="detail" @refresh="$emit('refresh')" />

    <div class="section-title">查询学员信息:</div>
    <el-table :data="[student]" border empty-text="暂无数据" style="width: 100%">
      <el-table-column prop="studentname" label="姓名" min-width="110" align="center" />
      <el-table-column prop="cardid" label="身份证号码" min-width="180" align="center" />
      <el-table-column prop="studentno" label="学员编号" min-width="120" align="center" />
      <el-table-column prop="schoolname" label="驾校名称" min-width="140" align="center" />
      <el-table-column prop="models" label="驾照类型" width="90" align="center" />
      <el-table-column prop="phone" label="手机号" min-width="120" align="center" />
      <el-table-column prop="openclassesdate" label="开训时间" min-width="155" align="center" />
    </el-table>

    <div class="section-title">查询未提交信息:</div>
    <MotorcycleLearningRecordTable :records="pendingRecords" />

    <div class="section-title">查询已提交学时信息:</div>
    <MotorcycleLearningRecordTable :records="reportedRecords" />

    <div class="section-title">查询被退回/失败信息:</div>
    <MotorcycleLearningRecordTable :records="failedRecords" />

    <div class="section-title">查询视频进度:</div>
    <el-table :data="detail.progress || []" border empty-text="暂无记录" style="width: 100%">
      <el-table-column prop="videoId" label="视频ID" min-width="210" />
      <el-table-column label="科目" width="80" align="center">
        <template slot-scope="scope">{{ scope.row.subject === 1 ? '科一' : '科四' }}</template>
      </el-table-column>
      <el-table-column prop="positionSeconds" label="已学秒数" width="110" align="center" />
      <el-table-column prop="videoDurationSeconds" label="视频秒数" width="110" align="center" />
      <el-table-column label="完成" width="80" align="center">
        <template slot-scope="scope">{{ scope.row.completed ? '是' : '否' }}</template>
      </el-table-column>
      <el-table-column prop="lastWatchedAt" label="最近学习" min-width="160" align="center" />
    </el-table>
  </div>
</template>

<script>
import MotorcycleLearningRecordTable from '@/components/system/MotorcycleLearningRecordTable.vue'
import MotorcycleManualStudyPanel from '@/components/system/MotorcycleManualStudyPanel.vue'

export default {
  name: 'MotorcycleLearningDetail',
  components: { MotorcycleLearningRecordTable, MotorcycleManualStudyPanel },
  props: {
    detail: { type: Object, required: true }
  },
  computed: {
    student () {
      return this.detail.student || {}
    },
    pendingRecords () {
      return this.recordsByStatus('READY_REPORT', 'REPORTING')
    },
    reportedRecords () {
      return this.recordsByStatus('REPORTED')
    },
    failedRecords () {
      return this.recordsByStatus('FAILED')
    }
  },
  methods: {
    focusManualStudy () {
      this.$refs.manualStudyPanel.focus()
    },
    recordsByStatus (...statuses) {
      return (this.detail.records || []).filter(record => statuses.includes(record.status))
    }
  }
}
</script>

<style lang="less" scoped>
.motorcycle-detail { padding: 10px; }
.section-title { padding: 16px 0 6px; font-size: 14px; font-weight: 500; }
.section-title:first-child { padding-top: 0; }
</style>
